export const subCategoryMap = {
  base: 'Inspection Fees',
  fees: 'Acquisition Fees',
  other: 'Other Acquisition Costs',
};
